<template>
  <v-app id="app" class="wrap">
    <SideNav/>
    <DimLayer :isOpen="isOpen" @click:bgDim="onClickBgDim"/>
    <header>
      <Header/>
    </header>
    <main class="mainContainer">
      <router-view :key="$route.fullPath"/>
      <v-snackbar
          v-model="snackbar"
          :multi-line="true"
      >
        {{ message }}

        <template v-slot:action="{ attrs }">
          <v-btn
              color="red"
              text
              v-bind="attrs"
              v-if="message.indexOf('로그인') > -1"
              @click="logout()"
          >
            Login
          </v-btn>
          <v-btn
              color="red"
              text
              v-bind="attrs"
              @click="closeSnackbar()"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </main>
    <footer>
      <Footer/>
    </footer>

  </v-app>
</template>

<script>
import DimLayer  from './components/DimLayer'
import SideNav from './sidenav/SideNav'
import Header from './header/Header'
import Footer from './footer/Footer'

export default {
  name: "Layout",
  components: {
    Header,
    SideNav,
    Footer,
    DimLayer
  },
  data() {
    return {
      isOpen:false,
    }
  },
  computed: {
    snackbar: {
      get() {
        return this.$store.state.error.snackbar;
      },
      set(v) {
        if(!v)
          this.$store.dispatch('error/hide');
      }
    },
    message() {
      return this.$store.state.error.message;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('user/logout');
      this.$router.push('/login');
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    onClickBgDim(e){
      if(e){
        // eslint-disable-next-line no-undef
        $('body').css({
          overflow:"hidden"
        });
      }else{
        // eslint-disable-next-line no-undef
        $('body').css({
          overflow:"auto"
        });
      }
      this.isOpen = e
    },
  }

}
</script>

<style scoped>

</style>
